import { cn } from "#lib/utils"

const beatSizes = {
    sm: { wrapper: "h-5 w-5 gap-1", beat: "w-1", tall: "h-4", short: "h-2.5" },
    md: { wrapper: "h-8 w-8 gap-1.5", beat: "w-1.5", tall: "h-6", short: "h-4" },
    lg: { wrapper: "h-12 w-12 gap-2", beat: "w-2", tall: "h-10", short: "h-6" },
} as const

const tileSizes = {
    sm: "size-8 text-base",
    md: "size-10 text-lg",
    lg: "size-12 text-xl",
} as const

export function TaktMark({
    className,
    size = "md",
    variant = "tile",
}: {
    className?: string
    size?: keyof typeof beatSizes
    variant?: "beat" | "tile"
}) {
    if (variant === "beat") {
        const styles = beatSizes[size]
        return (
            <span
                aria-hidden="true"
                className={cn(
                    "inline-flex shrink-0 items-end justify-center rounded-xl bg-primary/10",
                    styles.wrapper,
                    className,
                )}
            >
                <span className={cn("rounded-full bg-primary", styles.beat, styles.tall)} />
                <span className={cn("rounded-full bg-primary", styles.beat, styles.short)} />
            </span>
        )
    }

    return (
        <span
            aria-hidden="true"
            className={cn(
                "grid shrink-0 place-items-center rounded-xl bg-primary font-bold text-primary-foreground shadow-sm",
                tileSizes[size],
                className,
            )}
        >
            T
        </span>
    )
}
